module.exports = __webpack_public_path__ + "img/i_o_my_noti.5c07e4c6.svg";